export default {"src":"/_next/static/media/editor-placeholder.2768fed3.svg","height":615,"width":900};